<script setup>
import '@/assets/cloudCounter/css/style.css';
import { ref, defineProps, computed, watch, } from 'vue';
import Layout from '@/components/cloudCounter/Layout.vue';
import Process from '@/components/cloudCounter/Process.vue';
import CaseBox from '@/components/cloudCounter/CaseBox.vue';
import InfoBox from '@/components/cloudCounter/InfoBox.vue';

import { useRouter } from 'vue-router';
const router = useRouter();


// 是否要保人、被保險人兩者姓名相同
const isSame = ref(true);
// const isSame = ref(false);

// 要保人姓名 
const applicant = ref({
    checked: isSame.value,
    name: {
        key: '要保人',
        value: '林大富'
    },
    newName: {
        key: '新要保人姓名',
        value: '',
        placeholder: '請填寫新的要保人名稱',
        disabled: false
    }
});

// 被保險人姓名 
const insurant = ref({
    checked: isSame.value,
    name: {
        key: '被保險人',
        value: '林大富'
    },
    newName: {
        key: '新被保險人姓名',
        value: '',
        placeholder: '請填寫新的被保險人名稱',
        disabled: false
    }
});

const nextPageButtonDisabled = computed(() => {

    let hasApplicant;
    let hasInsurant;

    if (isSame.value) {
        hasApplicant = applicant.value.newName.value;
        hasInsurant = insurant.value.newName.value;
        return !(hasApplicant && hasInsurant);
    } else {
        hasApplicant = (applicant.value.checked) && applicant.value.newName.value;
        hasInsurant = (insurant.value.checked) && insurant.value.newName.value;
        return !(hasApplicant || hasInsurant);
    }

});


const checkInputText = (e, item) => {
    if (isSame.value) {
        const _Obj = (item === applicant.value) ? (insurant.value) : (applicant.value);
        if (e.target.value) {
            if (!(_Obj.newName.disabled)) {
                _Obj.newName.disabled = true;
            }
        } else {
            if (_Obj.newName.disabled) {
                _Obj.newName.disabled = false;
            }
        }
        _Obj.newName.value = e.target.value;
    }
};

const infoBoxVisble = ref(false);

const goNextPage = () => {
    infoBoxVisble.value = true;
};

const infoBoxOkHandel = () => {
    console.log("GO");
    router.push({ name: 'update-name-check' });
};

</script>

<template>

    <Layout :header="{ text: '要保人或被保險人姓名變更', backBtn: { visible: true }, closeBtn: { visible: false, to: {} }, }">

        <div class="pt-2 pb-6">
            <Process :steps="['選擇保單', '填寫內容', '確認資料', '視訊預約',]" :index="1"></Process>
        </div>

        <div class="pb-8">
            <h2 class="font-bold text-2xl pb-2">
                填寫欲變更的姓名
            </h2>
            <p v-if="isSame">若其餘保單有要保人、被保險人相同姓名，將一併辦理變更</p>
            <p v-else>若其餘保單有相同姓名，將一併辦理姓名變更</p>
        </div>

        <div class="pb-4">

            <CaseBox slotClass="p-0" :class="{'border border-[#0093C1]': !isSame && item.checked}" v-for="(item, i) in [applicant, insurant]">
                <div>
                    <label class="block p-4 font-bold">
                        <input class="align-text-bottom mr-2" type="checkbox" v-model="item.checked" v-if="!isSame">
                        {{ item.name.key }} <span v-if="item.name.key">：</span>{{ item.name.value }}
                    </label>
                </div>
                <div class="pb-4 px-4" v-show="isSame || item.checked">
                    <div class="pb-2 font-bold">{{ item.newName.key }}</div>
                    <input type="text" :placeholder="item.newName.placeholder" v-model="item.newName.value"
                        :disabled="item.newName.disabled" @input="(e) => { checkInputText(e, item) }" />
                </div>
            </CaseBox>

        </div>

        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="nextPageButtonDisabled" @click="goNextPage">確認</button>
        </template>

    </Layout>

    <InfoBox v-show="infoBoxVisble" :closeHandel="() => { infoBoxVisble = false; }" title="因以下保單有相同要保人與被保險人，將一併辦理姓名變更"
        :okHandel="infoBoxOkHandel" buttonText="我知道了">
        <div class="font-bold">相同要保人之保單：</div>
        <ul class="pl-6 pb-4 list-disc">
            <li>1066216930-00<br>XWO富邦人壽富利旺終身壽險</li>
            <li>1066216930-00<br>XWO富邦人壽富利旺終身壽險</li>
            <li>1066216930-00<br>XWO富邦人壽富利旺終身壽險</li>
            <li>1066216930-00<br>XWO富邦人壽富利旺終身壽險</li>
            <li>1066216930-00<br>XWO富邦人壽富利旺終身壽險</li>
            <li>1066216930-00<br>XWO富邦人壽富利旺終身壽險</li>
            <li>1066216930-00<br>XWO富邦人壽富利旺終身壽險</li>
            <li>1066216930-00<br>XWO富邦人壽富利旺終身壽險</li>
            <li>1066216930-00<br>XWO富邦人壽富利旺終身壽險</li>
            <li>1066216930-00<br>XWO富邦人壽富利旺終身壽險</li>
        </ul>
        <div class="font-bold">相同被保險人之保單：</div>
        <ul class="pl-6 pb-4 list-disc">
            <li>1066216930-00<br>XWO富邦人壽富利旺終身壽險</li>
            <li>1066216930-00<br>XWO富邦人壽富利旺終身壽險</li>
            <li>1066216930-00<br>XWO富邦人壽富利旺終身壽險</li>
            <li>1066216930-00<br>XWO富邦人壽富利旺終身壽險</li>
            <li>1066216930-00<br>XWO富邦人壽富利旺終身壽險</li>
            <li>1066216930-00<br>XWO富邦人壽富利旺終身壽險</li>
            <li>1066216930-00<br>XWO富邦人壽富利旺終身壽險</li>
            <li>1066216930-00<br>XWO富邦人壽富利旺終身壽險</li>
            <li>1066216930-00<br>XWO富邦人壽富利旺終身壽險</li>
            <li>1066216930-00<br>XWO富邦人壽富利旺終身壽險</li>
        </ul>
    </InfoBox>

</template>

<style scoped></style>
